<template>
  <router-view />
  <pwa-reload-prompt />
  <prime-toast position="top-center" />
  <prime-confirm-dialog />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import PwaReloadPrompt from '@/components/pwa-reload-prompt.vue'
import PrimeToast from 'primevue/toast'
import PrimeConfirmDialog from 'primevue/confirmdialog'
</script>
